import { useMemo } from 'react'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'
import {
  SheduleTableProps,
  BaseMaterialCleanChangeoverRowType,
} from './Scheduler.types'
import { Box } from '@mui/material'

const dataConfig = {
  required: [
    'kitchen_code',
    'previous_material_code',
    'next_base_material_code',
    'remove_clean',
    'other_changeover',
  ],
  optional: ['changeover_cost', 'changeover_environmental_cost'],
}

export const SchedulerBaseMaterialCleanChangeoverTable = ({
  data,
  isLoading,
  updateTableData,
  uploadScheduleData,
  isUploading,
  isSaving,
  updateRowsStatus,
  predicate,
  deleteTableData,
  isDeleting,
}: SheduleTableProps<BaseMaterialCleanChangeoverRowType>) => {
  // Handle data updates for BaseTable
  const handleDataUpdate = (
    changedRows: Record<number, BaseMaterialCleanChangeoverRowType>
  ) => {
    updateTableData(changedRows)
  }

  const columns: ExtendedGridColDef[] = useMemo(
    () => [
      {
        field: 'kitchen_code',
        headerName: 'Kitchen Code',
        type: 'string',
        flex: 1,
      },
      {
        field: 'previous_material_code',
        headerName: 'Previous Material Code',
        type: 'string',
        flex: 1,
      },
      {
        field: 'next_base_material_code',
        headerName: 'Next Base Material Code',
        type: 'string',
        flex: 1,
      },
      {
        field: 'remove_clean',
        headerName: 'Remove Clean',
        type: 'string',
        flex: 1,
        editable: true,
      },
      {
        field: 'other_changeover',
        headerName: 'Other Changeover',
        type: 'string',
        flex: 1,
        editable: true,
      },
      {
        field: 'changeover_cost',
        headerName: 'Changeover Cost',
        type: 'number',
        flex: 1,
        editable: true,
      },
      {
        field: 'changeover_environmental_cost',
        headerName: 'Changeover Environmental Cost',
        type: 'number',
        flex: 1,
        editable: true,
      },
    ],
    [data]
  )

  return (
    <Box>
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={isLoading}
        updateTableData={handleDataUpdate}
        uploadData={uploadScheduleData}
        isUploading={isUploading}
        isSaving={isSaving}
        checkBoxSelection={true}
        showTableToolBar={true}
        downloadFileName="SchedulerBaseMaterialCleanChangeover"
        onDeleteRows={deleteTableData}
        isDeleting={isDeleting}
        multiStageUpload={{
          uploadFile: uploadScheduleData,
          isUploading: isUploading,
          columns: columns,
          updateRowsStatus: updateRowsStatus,
          originalData: data,
          predicate: predicate,
          dataConfig: dataConfig,
        }}
        initialState={{
          pagination: { paginationModel: { pageSize: 100 } },
        }}
        sx={{
          maxWidth: 'calc(100vw - 70px)',
          '& .MuiDataGrid-cell--editable': {
            backgroundColor: '#CBD5E1',
          },
          '& .MuiBox-root': {
            padding: '0px !important',
          },
        }}
      />
    </Box>
  )
}
